import React, { useState, useMemo } from "react";
import { Modal, DatePicker, Form } from "antd";
import { useSelector } from "react-redux";
import CustomSelect from "../../../Reuseable/Select/Select";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import "./ExportModal.scss";
import { exportAllocationData } from "../../../assets/api/agency";
import CustomNotification from "../../../Reuseable/CustomNotification/CustomNotification";
import dayjs from "dayjs";
import { useEffect } from "react";

const ExportModal = ({ open, onClose, exportFunction = exportAllocationData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { token, user } = useSelector((state) => state.auth);
  const { filter_list } = useSelector((state) => state.filters);

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  const portfoliosData = useMemo(() => {
    return (
      filter_list?.find((item) => item?.name === "portfolios")?.filters || []
    );
  }, [filter_list]);

  const dispositionData = useMemo(() => {
    return (
      filter_list?.find((item) => item?.name === "disposition")?.filters || []
    );
  }, [filter_list]);

  const telecallerData = useMemo(() => {
    return (
      filter_list?.find((item) => item?.name === "telecallers")?.filters || []
    );
  }, [filter_list]);

  const portfolioOptions = useMemo(
    () => portfoliosData.map((p) => ({ label: p.name, value: p.id })),
    [portfoliosData],
  );
  const dispositionOptions = useMemo(
    () => dispositionData.map((d) => ({ label: d.value, value: d.key })),
    [dispositionData],
  );
  const telecallerOptions = useMemo(
    () => telecallerData.map((t) => ({ label: t.name, value: t.id })),
    [telecallerData],
  );

  const exactDate = Form.useWatch("date", form);
  const startDate = Form.useWatch("start_date", form);
  const endDate = Form.useWatch("end_date", form);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const params = {};
      if (values.portfolio && values.portfolio.length > 0) {
        params.portfolio = values.portfolio.join(",");
      }
      if (values.disposition && values.disposition.length > 0) {
        params.disposition = values.disposition.join(",");
      }
      if (values.telecaller && values.telecaller.length > 0) {
        params.telecaller = values.telecaller.join(",");
      }
      if (values.date) {
        params.date = dayjs(values.date).format("YYYY-MM-DD");
      }
      if (values.start_date) {
        params.start_date = dayjs(values.start_date).format("YYYY-MM-DD");
      }
      if (values.end_date) {
        params.end_date = dayjs(values.end_date).format("YYYY-MM-DD");
      }

      const res = await exportFunction(params, token);
      console.log(res, "exportDataConsole");
      CustomNotification.show("Export initiated successfully!");
      onClose();
    } catch (error) {
      console.log(error, "error");
      CustomNotification.show(error?.message, 400);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Export Cases Data"
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
      className="exportModalMain"
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="exportForm"
      >
        <div className="RowWrapper">
          <Form.Item name="portfolio" label="Portfolio">
            <CustomSelect
              placeholder="Select Portfolio"
              isMultiSelect={true}
              options={portfolioOptions}
            />
          </Form.Item>
          <Form.Item name="disposition" label="Disposition">
            <CustomSelect
              placeholder="Select Disposition"
              isMultiSelect={true}
              options={dispositionOptions}
            />
          </Form.Item>
        </div>
        <div className="RowWrapper">
          {!user?.is_tc && (
            <Form.Item name="telecaller" label="Telecaller">
              <CustomSelect
                placeholder="Select Telecaller"
                isMultiSelect={true}
                options={telecallerOptions}
              />
            </Form.Item>
          )}
          <Form.Item name="date" label="Exact Date">
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              disabled={!!startDate || !!endDate}
              onChange={(val) => {
                if (val) {
                  form.setFieldsValue({ start_date: null, end_date: null });
                }
              }}
            />
          </Form.Item>
        </div>

        <div className="dateRangeWrapper">
          <Form.Item name="start_date" label="Start Date">
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              disabled={!!exactDate}
              onChange={(val) => {
                if (val) form.setFieldsValue({ date: null });
              }}
            />
          </Form.Item>
          <Form.Item name="end_date" label="End Date">
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              disabled={!!exactDate}
              onChange={(val) => {
                if (val) form.setFieldsValue({ date: null });
              }}
            />
          </Form.Item>
        </div>

        <div className="submitWrapper">
          <NormalButton htmlType="submit" loading={loading}>
            Export Data
          </NormalButton>
        </div>
      </Form>
    </Modal>
  );
};

export default ExportModal;
